const data = {
  countries:
 [
  "PHILIPPINES"
 ],
 city:[

"MATI",
"DON SALVADOR BENEDICTO",
"SANTA TERESITA",
"SANTOL",
"STO. CRISTO",
"STO. NIÑO",
"SAUYO",
"SIENNA",
"SIKATUNA VILLAGE",
"SILANGAN",
"SOCORRO",
"SOUTH TRIANGLE",
"TAGUMPAY",
"TALAMPAS",
"TALAYAN",
"TALIPAPA",
"TANDANG SORA",
"TATALON",
"TEACHERS VILLAGE",
"UGONG NORTE",
"UNANG SIGAW",
"U.P.P.O.",
"U.P. VILLAGE",
"VALENCIA",
"VASRA",
"VETERANS VILLAGE",
"VILLA MARIA CLARA",
"VIOLAGO HOMES",
"WEST TRIANGLE",
"WHITE PLAINS",
"BRAULIO E. DUJALI",
"NAUJAN",
"TAMPARAN",
"TARAKA",
"WAO",
"AGOO",
"ARINGAY",
"BACNOTAN",
"BAGULIN",
"BALAOAN",
"BANGAR",
"BAUANG",
"BURGOS",
"CABA",
"DAMORTIS",
"LUNA",
"NAGUILLAN",
"PUGO",
"ROSARIO",
"SAN FERNANDO",
"SAN GABRIEL",
"SAN JUAN",
"SANTOL",
"SANTO TOMAS",
"SUDEPEN",
"TUBAO",
"ABUYOG",
"ALANGALANG",
"ALBUERA",
"BABATNGON",
"BARUGO",
"BATO",
"BAYBAY",
"BURAUEN",
"CALUBIAN",
"CAPOOCAN",
"CARIGARA",
"DAGAMI", "DULAG", "HILONGOS", "HINDANG", "INOPACAN", "ISABEL", "JARO", "JAVIER", "JULITA", "KANANGA",
    "LA PAZ", "LEYTE", "GENERAL MAC ARTHUR", "MAHAPLAG", "MATAG-OB", "MATALOM", "MAYORGA", "PULANG LUPA & ZAPOTE",
    "PULANG LUPA", "AYALA", "PASEO DE ROXAS", "BANGKAL", "BEL-AIR", "CEMBO", "PANITAN", "PILAR", "PRES. ROXAS",
    "PUNTEVEDRA", "ROXAS CITY", "SAPIAN", "TAPAZ", "BAGAMANOC", "BARAS", "BATO", "CARAMORAN", "GIGMOTO", "PANDAN",
    "PANGANIBAN", "SAN ANDRES", "SAN MIGUEL", "BAGONG BUHAY", "BAGONG LIPUNAN", "BAGONG PAG-ASA", "BAGONG SILANGAN",
    "BAGUMBAYAN", "BAHAY TORO", "BALINGASA", "BALINTAWAK", "BALUMBATO", "BATASAN HILLS", "BAYANIHAN", "BF HOMES",
    "BLUE RIDGE", "BOTOCAN", "BUNGAD", "CAMP AGUINALDO", "CAPITOL HILLS/PARK", "CAPRI", "CENTRAL", "CLARO", "COMMONWEALTH",
    "CRAME", "CUBAO", "CULIAT", "DAMAR", "DAMAYAN", "DAMAYAN LAGI", "DAMONG MALIIT", "DEL MONTE", "DILIMAN", "DIOQUINO ZOBEL",
    "DON MANUEL", "DONA AURORA", "DONA FAUSTINA SUBD.", "DOÑA IMELDA", "DONA JOSEFA", "DUYAN-DUYAN", "SAN JUAN", "SAN VICENTE",
    "SANTA", "SANTA CATALINA", "SANTA CRUZ", "SANTA LUCIA", "SANTA MARIA", "SANTIAGO", "SANTO DOMINGO", "SICAY", "SINAIT",
    "SUGPON", "SUYO", "TAGUDIN", "VIGAN", "AJUY", "ALIMODIAN", "ANILAO", "BADIANGAN", "BALASAN", "BANATE", "BAROTAC NUEVO",
    "BAROTAC VIEJO",

    "BATAD",
    "BINGAWAN",
    "CABATUAN",
    "CALINOG",
    "CARLES",
    "CONCEPTION",
    "DINGLE",
    "DUEÑAS",
    "TAMPILISAN",
    "ALICIA",
    "AURORA",
    "BAYOG",
    "BUUG",
    "DIMATALING",
    "DINAS",
    "DIPLAHAN",
    "DON MARIANO MARCOS",
    "DUMALINAO",
    "DUMINGAG",
    "GUIPOS",
    "IMELDA",
    "IPIL",
    "JOSEFINA",
    "KABASALAN",
    "KUMALARANG",
    "LABANGAN",
    "LAKEWOOD",
    "LAPUYAN",
    "MABUHAY",
    "MAHAYAG",
    "MALANGAS",
    "MARGO SA TUBIG",
    "MIDSALIP",
    "MOLAVE",
    "COMEMBO",
    "E. RODRIGUEZ",
    "NAGA",
    "GUMACA",
    "HONDAGUA",
    "INFANTA",
    "JOMALIG",
    "LOPEZ",
    "LUCBAN",
    "LUCENA CITY",
    "MACALELON",
    "MAUBAN",
    "MULANAY",
    "PADRE BURGOS",
    "PAGBILAO",
    "PANUKULAN",
    "PATNONANGAN",
    "PEREZ",
    "INFANTA",
    "LABRADOR",
    "LAOAC",
    "LINGAYEN",
    "MABINI",
    "MALASIQUI",
    "MANAOAG",
    "MANGALDAN",
    "MANGATAREM",
    "MAPANDAN",
    "NATIVIDAD",
    "POZORRUBIO",
    "ROSALES",
    "SAN CARLOS CITY",
    "SAN FABIAN",
    "SAN JACINTO",
    "SAN MANUEL",
    "SAN NICOLAS",
    "SAN QUINTIN",
    "SANTA BARBARA",
    "SANTA MARIA",
    "SANTO TOMAS",
    "SISON",
    "SUAL",
    "TAYUG",
    "UMINGAN",
    "URBIZTONDO",
    "URDANETA",
    "VILLASIS",
    "AGDANGAN",
    "ALABAT",
    "ATIMONAN",
    "BUENAVISTA",
    "BURDEOS",
    "CALAUAG",

    "CANDELARIA",
    "CATANUAN",
    "DOLORES",
    "GEN. LUNA",
    "GEN. NAKAR",
    "GUINAYANGAN",
    "DASMARINAS VILLAGE NORTH",
    "DASMARINAS VILLAGE SOUTH",
    "FORBES PARK NORTH",
    "FORBES PARK SOUTH",
    "FORT BONIFACIO NAVAL STN.",
    "FORT BONIFACIO (CAMP)",
    "GREENBELT",
    "GUADALUPE NUEVO",
    "GUADALUPE VIEJO",
    "KASILAWAN",
    "LA PAZ",
    "SINGKAMAS",
    "TEJEROS",
    "LEGASPI VILLAGE",
    "MAGALLANES VILLAGE",
    "MAKATI COMMERCIAL CTR.",
    "MAKATI CPO + BUENDIA AVE",
    "OLYMPIA",
    "CARMONA",
    "PALANAN",
    "PASONG TAMO",
    "ECOLOGY VILL",
    "PEMBO",
    "PITOGO",
    "PINAGKAISAHAN",
    "PIO DEL PILAR",
    "POBLACION",
    "REMBO (EAST)",
    "REMBO (WEST)",
    "SALCEDO VILLAGE",
    "SAN ANTONIO VILLAGE",
    "SAN ISIDRO",
    "CORTEZ",
    "DAGUHOY",
    "DANAO",
    "DAUIS",
    "DIMIAO",
    "DUERO",
    "GARCIA HERNANDEZ",
    "GUINDULMAN",
    "INABANGA",
    "JAGNA",
    "JETAFE",
    "LILA",
    "LOAY",
    "LOBOC",
    "LOON",
    "MABINI",
    "MARIBOJOC",
    "PANGLAO",
    "ESCOPA",
    "FAIRVIEW",
    "FAIRVIEW NORTH",
    "FAIRVIEW SOUTH",
    "GINTONG SILAHIS",
    "GULOD",
    "VIGA",
    "VIRAC",
    "ALFONSO",
    "AMADEO",
    "BACOOR",
    "CARMONA",
    "CAVITE CITY",
    "CAVITE NAVAL BASE",
    "CORREGIDOR",
    "DASMARINAS",
    "DASMARINIAS RESETTLEMENT AREA",
    "GEN. AGUINALDO (BAILEN)",
    "GEN. MARIANO ALVAREZ",
    "GEN. TRIAS",
    "IMUS",
    "INDANG",
    "KAWIT",
    "MAGALLANES",
    "MARAGONDON",
    "MENDEZ",
    "NAIC",
    "NOVELETA",
    "ROSARIO",
    "SILANG",
    "TAGAYTAY CITY",
    "TANZA",
    "TERNATE",
    "TRECE MARTIRES CITY",
    "COMPOSTELA",
    "LAAK",
    "MABINI",
    "MACO",
    "MARAGUSAN",
    "MAWAB",
    "MONKAYO",
    "MONTEVISTA",
    "NABUNTURAN",
    "NEW BATAAN",
    "PANTUKAN",
    "ALCANTARA",
    "ALCOY",
    "ALEGRIA",
    "ALOGUINSAN",
    "ARGAO",
    "ASTURIAS",
    "BADIAN",
    "BALAMBAN",
    "TAGOLOAN",
    "OLUTANGA",
    "PAGADIAN CITY",
    "PAYAO",
    "PITOGO",
    "RAMON MAGSAYSAY",
    "RESELLER LIM",
    "SAN MIGUEL",
    "SAN PABLO",
    "SIAY",
    "TABINA",
    "TALUSAN",
    "TAMBULIG",
    "TIGBAD",
    "TITAY",
    "TUKURAN",
    "TUNGAWAN",
    "VICENCIO SAGUN",
    "ZAMBOANGA CITY",
    "AKBAR",
    "AL-BARKA",
    "HADJI MOHAMMAD AJUL",
    "HADJI MUHTAMAD",
    "ISABELA CITY",
    "LAMITAN",
    "LANTAWAN",
    "MALUSO",
    "SUMISIP",
    "TABUAN-LASA",
    "TIPO-TIPO",
    "TUBURAN",
    "UNGKAYA PUKAN",
    "SARIAYA",
    "TAGKAWAYAN",
    "TAYABAS",
    "TIAONG",
    "UNISAN",
    "AGLIPAY",
    "CABARRUGUIS",
    "DIFFUN",
    "MADDELA",
    "NAGTIPUNAN (ABBAG)",
    "SAGUDAY",
    "PITOGO",
    "PLARIDEL",
    "POLILIO",
    "QUEZON",
    "QUEZON CAPITOL",
    "REAL",
    "SAMPALOC",
    "SAN ANDRES",
    "SAN ANTONIO",
    "SAN FRANCISCO",
    "SAN NARCISO",
    "DUMANGAS",
    "ESTANCIA",
    "GUIMBAL",
    "IGBARAS",
    "ILOILO CITY",
    "JANIUAY",
    "LAMBUNAO",
    "LEGANES",
    "LEMERY",
    "LEON",
    "MAASIN",
    "MIAGAO",
    "MINA",
    "NEW LUCENA",
    "OTON",
    "PASSI",
    "PAVIA",
    "POTOTAN",
    "SAN DIONISIO",
    "SAN ENRIQUE",
    "SAN JOAQUIN",
    "SAN MIGUEL",
    "SAN RAFAEL",
    "SANTA BARBARA",
    "SARA",
    "TIGBAUAN",
    "TUBUNGAN",
    "ZARRAGA",
    "ALICIA",
    "ANGADANAN",
    "AURORA",
    "BENITO SOLIVEN",
    "BURGOS",
    "CABAGAN",
    "CABATUAN",
    "PILAR",

    "SAGBAYAN",
    "SAN ISIDRO",
    "SAN MIGUEL",
    "SEVILLA",
    "SIERRA BULLONES",
    "SIKATUNA",
    "TAGBILARAN CITY",
    "TALIBON",
    "TRINIDAD",
    "TUBIGON",
    "UBAY",
    "VALENCIA",
    "BAUNGON",
    "DAMULOG",
    "DANGCAGAN",
    "DON CARLOS",
    "IMPASUGONG",
    "KABANGLASAN",
    "KADINGILAN",
    "KALILANGAN",
    "KIBAWE",
    "KITAOTAO",
    "LANTAPAN",
    "LIBONA",
    "MALAYBALAY",
    "MALITBOG",
    "MANOLO FORTICH",
    "MARAMAG",
    "MUSUAN",
    "PANGANTUCAN",
    "SAN LORENZO VILLAGE",
    "STA. CRUZ",
    "URDANETA VILLAGE",
    "RIZAL",
    "VALENZUELA",
    "SANTIAGO",
    "ACACIA",
    "ARANETA SUBDIVISION",
    "DAMPALIT",
    "FLORES",
    "KAUNLARAN VILLAGE",
    "LONGOS",
    "MALABON",
    "MAYSILO",
    "MUZON",
    "POTRERO",
    "SANTOLAN",
    "TONSUYA",
    "EAST EDSA",
    "GREENHILLS SOUTH",
    "MANDALUYONG CPO",
    "NATIONAL MENTAL HOSPITAL",
    "TALISAYAN",
    "VILLANUEVA",
    "BARLIG",
    "BAUKO",
    "BESAO",
    "BONTOC",
    "NATONIN",
    "PARACELIS",
    "SABANGAN",
    "SADANGA",
    "SAGADA",
    "TADIAN",
    "BACOLOD CITY",
    "BAGO CITY",
    "BINALBAGAN",
    "CADIZ CITY",
    "CALATRAVA",
    "CANDONI",
    "ENRIQUE MAGALONA",
    "ESCALANTE",
    "HIMAMAYLAN",
    "HINIGARAN",
    "HINOBA-ARI",
    "ILOG",
    "ISABELA",
    "KABANKALAN",
    "KAUAYAN",
    "LA CARLOTA CITY",
    "LA CASTILLANA",
    "MANAPLA",
    "MOISES PADILLA",
    "MURCIA",
    "PARAISO (FABRICA)",
    "PULUPANDAN",
    "PONTEVEDRA",
    "SAGAY",
    "SAN CARLOS CITY",
    "SAN ENRIQUE",
    "SILAY CITY",
    "SILAY HAWAIIAN CENTRAL",
    "SIPALAY",
    "TALISAY",
    "TOBOSO",
    "VALLADOLID",
    "VICTORIAS",
    "BANTAYAN",
    "BARILI",
    "BOGO",
    "BOLJOON",
    "BORBON",
    "CARCAR",
    "CARMEN",
    "CATMON",
    "CEBU CITY",
    "COMPOSTELA",
    "CAUAYAN",
    "CORDON",
    "DELFIN ALBANO",
    "DINAPIGUI",
    "DIVILACAN",
    "ECHAGUE",
    "GAMU",
    "ILAGAN",
    "JONES",
    "LUNA",
    "MACONACON",
    "MALLIG",
    "NAGUILLAN",
    "PALANAN",
    "QUEZON",
    "PILAR",
    "SAL-LAPADAN",
    "SAN ISIDRO",
    "SAN JUAN",
    "SAN QUINTIN",
    "TAYUM",
    "TINEG",
    "TUBO",
    "VILLAVICIOSA",
    "BUENAVISTA",
    "BUTUAN CITY",
    "CABADBARAN",
    "CARMEN",
    "JABONGA",
    "KITCHARAO",
    "LA NIEVES",
    "MAGALLANES",
    "NASIPIT",
    "REMEDIOS T. ROMUALDEZ",
    "SANTIAGO",
    "TUBAY",
    "BAYUGAN",
    "BUNAWAN",
    "ESPERANZA",
    "LA PAZ",
    "LORETO",
    "PROSPERIDAD",
    "ROSARIO",
    "SAN FRANCISCO",
    "SAN LUIS",
    "SANTA JOSEFA",
    "SIBAGAT",
    "TALACOGON",
    "TRENTO",
    "VERUELA",
    "ALTAVAS",
    "BALITE",
    "BANGA",
    "BATAN",
    "BURUANGA",
    "IBAJAY",
    "KALIBO",
    "LEZO",
    "SHAW BOULEVARD",
    "VERGARA",
    "WACK WACK GOLF CLUB",
    "BAGONG NAYON",
    "BARANGKA",
    "COGEO",
    "CONCEPTION 1",
    "CONCEPTION 2",
    "CUPANG",
    "INDUSTRIAL VALLEY",
    "J DE LA PENA",
    "LANGHAYA",
    "MALANDAY",
    "MAMBAGAT",
    "MARIKINA CPO",
    "MARIKINA HEIGHTS",
    "MAYAMOT",
    "NANGKA",
    "NORTH/WEST OF MARIKINA RIVER",
    "PARANG",
    "SAN ROQUE-CALUMPANG",
    "PHILIPS",
    "QUEZON",
    "SAN FERNANDO",
    "SUMILAO",
    "TALAKAG",
    "VALENCIA",
    "ANGAT",
    "BALAGTAS",
    "BALIUAG",
    "BOCAUE",
    "BULACAN",
    "BUSTOS",
    "CALUMPIT",
    "DONA REMEDIOS TRINIDAD",
    "GUIGUINTO",
    "HAGONOY",
    "MALOLOS",
    "MARILAO",
    "MEYCAUAYAN",
    "NORZAGARAY",
    "OBANDO",
    "PANDI",
    "PAOMBONG",
    "PLARIDEL",
    "PULILAN",
    "SAN ILDEFONSO",
    "SAN JOSE DEL MONTE",
    "SAN MIGUEL",
    "SAN RAFAEL",
    "SANTA MARIA",
    "SAPANG PALAY",
    "CONSOLACION",
    "CORDOVA",
    "DAANBANTAYAN",
    "DALAGUETE",
    "DANAO",
    "DUMANJUG",
    "GINATILAN",
    "LAPU-LAPU CITY",
    "LILOAN",
    "MACTAN AIRPORT",
    "MADRIDEJOS",
    "MALABUYOC",
    "MANDAUE CITY",
    "MEDELLIN",
    "MINGLANILLA",
    "MOALBOAL",
    "NAGA",
    "OSLOB",
    "PILAR",
    "PINAMUNGAHAN",
    "PORO",
    "RONDA",
    "SAMBOAN",
    "SAN FERNANDO",
    "SAN FRANCISCO",
    "SAN REMEGIO",
    "SANTA FE",
    "SANTANDER",
    "SIBONGA",
    "SOGOD",
    "TABOGON",
    "TABUELAN",
    "TALISAY",
    "TOLEDO CITY",
    "TUBURAN",
    "TODELA",
    "ALAMADA",
    "ALEOSAN",
    "ANTIPAS",
    "AMLAN",
    "AYUNGON",
    "BACONG",
    "BAIS CITY",
    "BASAY",
    "BAYAWAN",
    "BINDOY",
    "CANLAON CITY",
    "DAUIN",
    "DUMAGUETE CITY",
    "GUIHULNGAN",
    "JIMALALUD",
    "LA LIBERTAD",
    "MABINAY",
    "MANJUYOD",
    "PAMPLONA",
    "SAN JOSE",
    "LIBACAO",
    "MADALAG",
    "MAKATO",
    "MALAY",
    "MALINAO",
    "NABAS",
    "MABITAC",
    "QUIRINO",
    "RAMON",
    "REINA MERCEDES",
    "ROXAS",
    "SAN AGUSTIN",
    "SAN GUILLERMO",
    "SAN ISIDRO",
    "SAN MIGUEL (CALLANG)",
    "SAN MARIANO",
    "SAN MATEO",
    "SAN PABLO",
    "SANTA MARIA",
    "SANTIAGO",
    "SANTO TOMAS",
    "TUMAUINI",
    "BALBALAN",
    "CALANASAN",
    "CONNER",
    "FLORA",
    "KABUGAO",
    "RIZAL",
    "LUBUAGAN",
    "LUNA",
    "PASIL",
    "PINUKPUK",
    "PUDTOL",
    "SANTA MARCELA",
    "TABUK",
    "TANUDAN",
    "TINGLAYAN",
    "ALAMINOS",
    "BAY",
    "BINAN",
    "BOTOCAN",
    "CABUYAO",
    "CALAMBA CITY",
    "CALAUAN",
    "CAMP VICENTE LIM",
    "CANLUBANG",
    "CAVINTI",
    "COLLEGE LOS BANOS",
    "FAMY",
    "KALAYAAN",
    "LILIW",
    "LOS BANOS",
    "LUISIANA",
    "LUMBAN",
    "NEW WASHINGTON",
    "NUMANCIA",
    "ABULOG",
    "ALCALA",
    "ALLACAPAN",
    "AMULUNG",
    "APARRI",
    "BAGGAO",
    "BALLESTEROS",
    "BUGUEY",
    "CALAYAN",
    "CAMALANIUGAN",
    "CLAVERIA",
    "ENRILE",
    "GATTARAN",
    "GONZAGA",
    "IGUIG",
    "LAL-LO",
    "LASAM",
    "MERIDA",
    "ORMOC CITY",
    "PALO",
    "PALUMPON",
    "PASTRANA",
    "SAN ISIDRO",
    "SAN MIGUEL",
    "SANTA FE",
    "TABANGO",
    "TABONTABON",
    "TACLOBAN CITY",
    "TANAUAN",
    "TOLOSA",
    "TUNGA",
    "VILLABA",
    "ANAHAWAN",
    "BOMTOC",
    "HINUNANGAN",
    "HINUNDAYAN",
    "LIBAGON",
    "LILOAN",
    "MAASIN",
    "MACROHON",
    "MALITBOG",
    "PADRE BURGOS",
    "PINTUYAN",
    "SAN FRANCISCO",
    "SAN JUAN (CABALIAN)",
    "SAN RICARDO",
    "SILAGO",
    "SOGOD",
    "ST. BERNARD",
    "TOMAS OPPUS",
    "AMPATUAN",
    "BARIRA",
    "BULDON",
    "BULUAN",
    "COTABATO CITY",
    "DATU PAGLAS",
    "DATU PIANG",
    "SIATON",
    "SIBULAN",
    "STA. CATALINA",
    "TANJAY",
    "TAYASAN",
    "VALENCIA",
    "VALLE HERMOSO",
    "ZAMBOANGUITA",
    "ALIAGA",
    "BONGABON",
    "CABANATUAN CITY",
    "CABIAO",
    "CARRANGLAN",
    "CENTRAL LUZON STATE UNIVERSITY (CLSU)",
    "CUYAPO",
    "FORT MAGSAYSAY",
    "GABALDON",
    "GAPAN",
    "GEN. M. NATIVIDAD",
    "GEN. TINIO",
    "GUIMBA",
    "JAEN",
    "LAUR",
    "LUCAB",
    "LLANERA",
    "LUPAO",
    "MUNOZ",
    "NAMPICUAN",
    "PALAYAN CITY",
    "PANTABANGAN",
    "HOLY SPIRIT",
    "HORSESHOE",
    "IMMACULATE CONCEPTION",
    "KALIGAYAHAN",
    "KALUSUGAN",
    "KAMIAS",
    "KAMUNING",
    "KATIPUNAN",
    "KAUNLARAN",
    "KRISTONG HARI",
    "KRUS NA LIGAS",
    "LAGING HANDA",
    "LA LOMA",
    "LIBIS",
    "LOURDES",
    "LOYOLA HEIGHTS",
    "MAHARLIKA",
    "MALAYA",
    "MANGGA",
    "MANRESA",
    "MARIANA",
    "MARIBLO",
    "MARILAG",
    "MASAGANA",
    "ANTIPOLO",
    "MONTALBAN (RODRIGUEZ)",
    "SAN MATEO",
    "TERESA",
    "ANGONO",
    "BARAS",
    "BINANGONAN",
    "CAINTA",
    "CARDONA",
    "JALA-JALA",
    "MORONG",
    "PILILIA",
    "TANAY",
    "TAYTAY",
    "ALCANTARA",
    "BANTON (JONES)",
    "CAJIDIOCAN",
    "CALATRAVA",
    "CONCEPTION",
    "CORCUERA",
    "FERROL",
    "IMELDA",
    "LOOC",
    "MAGDIWANG",
    "ODIONGAN",
    "ROMBLON",
    "SAN AGUSTIN",
    "SAN ANDRES",
    "SAN FERNANDO",
    "SAN JOSE",
    "SANTA FE",
    "ARTECHE",
    "BALANGIGA",
    "BALANGKAYAN",
    "TANGALAN",
    "BACACAY",
    "CAMALIG",
    "DARAGA (LOCSIN)",
    "GUINOBATAN",
    "JOVELLAR",
    "LEGAZPI CITY",
    "LIBON",
    "LIGAO",
    "MALILIPOT",
    "MALINAO",
    "MANITO",
    "OAS",
    "PIO DURAN (MALACBALAC)",
    "POLANGUI",
    "RAPU-RAPU",
    "STO. DOMINGO",
    "TABACO",
    "TIWI",
    "ANINI-Y",
    "BARBASA",
    "BELISON",
    "BUGASONG",
    "CALUYA",
    "CULASI",
    "HAMTIC",
    "LAWA-AN",
    "LIBERTAD",
    "PANDAN",
    "PATNONGAN",
    "SAN JOSE",
    "SAN REMEDIO",
    "SEBASTE",
    "SIBALOM",
    "TOBIAO",
    "TOBIAS FORNIER (DAO)",
    "VALDERAMA",
    "BALER",
    "CASIGURAN",
    "DILASAG",
    "DINALUNGAN",
    "DINGALAN",
    "DIPACULAO",
    "MARIA AURORA",
    "SAN LUIS",
    "ABUCAY",
    "MAGDALENA",
    "MAJAYJAY",
    "NAGCARLAN",
    "PAETE",
    "PAGSANJAN",
    "PAKIL",
    "PANGIL",
    "PILA",
    "RIZAL",
    "SAN PABLO CITY",
    "SAN PEDRO",
    "DATU ODIN SINSUAT (DINAIG)",
    "GEN. S. K. DATUN",
    "KABUNTULAN",
    "MAGANOY",
    "MATANOG",
    "PAGALUNGAN",
    "PARANG",
    "PAMPLONA",
    "PENABLANCA",
    "PIAT",
    "RIZAL",
    "SANCHEZ MIRA",
    "SANTA ANA",
    "SANTA PRAXEDES",
    "SANTA TERESITA",
    "SANTO NINO",
    "SOLANA",
    "TUAO",
    "TUGUEGARAO",
    "BASUD",
    "CAPALONGA",
    "DAET",
    "IMELDA",
    "JOSE PANGANIBAN",
    "LABO",
    "MERCEDEZ",
    "PARACALE",
    "SAN VICENTE",
    "SANTA ELENA",
    "TALISAY",
    "VINZONS",
    "TULAY NA LUPA",
    "BAAO",
    "BALATAN",
    "BATO",
    "BOMBON",
    "BUHI",
    "BULA",
    "CABUSAO",
    "CALABANGA",
    "CAMALIGAN",
    "CANAMAN",
    "CARAMOAN",
    "DEL GALLEGO",
    "GAINZA",
    "GARCHITORENA",
    "GOA",
    "IRIGA CITY",
    "MASAMBONG",
    "MATALAHIB",
    "MATANDANG BALARA",
    "MILAGROSA",
    "NAGKAISANG NAYAON",
    "NAYON KAUNLARAN",
    "NEW ERA",
    "NOVALICHES TOWN PROPER",
    "OBRERO",
    "OLD CAPITOL SITE",
    "PAANG BUNDOK",
    "PAG-IBIG SA NAYON",
    "PALIGSAHAN",
    "PALTOK",
    "PANSOL",
    "PARAISO",
    "PASONG PUTIK",
    "PASONG TAMO",
    "PAYATAS",
    "PHIL-AM / PHILAM",
    "PENARANDA",
    "QUEZON",
    "RIZAL",
    "SAN ANTONIO",
    "SAN ISIDRO",
    "SAN JOSE CITY",
    "SAN LEONARDO",
    "SANTA ROSA",
    "SANTO DOMINGO",
    "TALAVERA",
    "TALUGTOG",
    "ZARAGOSA",
    "ALFONSO CASTAÑEDA",
    "AMBAGUIO",
    "ARITAO",
    "BAGABAG",
    "BAMBANG",
    "BAYOMBONG",
    "DIADI",
    "DUPAX DEL NORTE",
    "DUPAX DEL SUR",
    "KASIBU",
    "KAYAPA",
    "QUEZON",
    "SOLANO",
    "STA. FE (IMUGAN)",
    "VILLA VERDE (IBUNG)",
    "ABORLAN",
    "AGUTAYA",
    "ARACELI",
    "BALABAC",
    "BATARAZA",
    "BORONGAN",
    "CAN-AVID",
    "DOLORES",
    "GEN. MCARTHUR",
    "GIPORLOS",
    "GUIUAN",
    "HERNANI",
    "JIPAPAD",
    "LAWA-AN",
    "LLORENTE",
    "MASLOG",
    "MAYDULOG",
    "MERCEDES",
    "ORAS",
    "QUINAPUNDAN",
    "SALCEDO",
    "SAN JULIAN",
    "SAN POLICARPIO",
    "SULAT",
    "TAFT",
    "ALLEN",
    "BIRI",
    "BOBON",
    "CAPUL",
    "CATARMAN",
    "CATUBIG",
    "GAMAY",
    "LA NAVAS",
    "LAOANG",
    "LAPINEG",
    "LAVEZARES",
    "LOPE DE VEGA",
    "MAPANAS",
    "MONDRAGON",
    "PALAPAG",
    "PAMBUJAN",
    "ROSARIO",
    "SAN ANTONIO",
    "SAN ISIDRO",
    "SAN JOSE",
    "SAN ROQUE",
    "SAN VICENTE",
    "SILVINO LUBOS",
    "VICTORIA",
    "ALMAGRO",
    "BASEY",
    "CALBAYOG CITY",
    "CALBIGA",
    "CATBALOGAN CITY",
    "DARAM",
    "GANDARA",
    "HINABANGAN",
    "JIABONG",
    "MARABUT",

    "MATUGUINAO",
    "MOTIONG",
    "PAGSANJAN",
    "SANTA CRUZ",
    "SANTA MARIA",
    "SANTA ROSA",
    "SINILOAN",
    "VICTORIA",
    "BACOLOD",
    "BALOI",
    "BAROY",
    "ILIGAN CITY",
    "KAPATAGAN",
    "KAROMATAN",
    "KAUSWAGAN",
    "KOLAMBUGAN",
    "LALA",
    "LINAMON",
    "BINONDO",
    "INTRAMUROS",
    "MALATE",
    "MANILA CPO - ERMITA",
    "PACO",
    "PANDACAN",
    "PORT AREA (SOUTH)",
    "QUIAPO",
    "SAMPALOC EAST",
    "SAMPALOC WEST",
    "SAN ANDRES BUKID",
    "SAN MIGUEL",
    "SAN NICOLAS",
    "STA. ANA",
    "STA. CRUZ NORTH",
    "STA. CRUZ SOUTH",
    "STA. MESA",
    "TONDO NORTH",
    "TONDO SOUTH",
    "AMPARO SUBDIVISION",
    "BAGONG SILANG",
    "BAGUMBONG/PAG-ASA",
    "BANKERS VILLAGE",
    "BAGAC",
    "BALANGA",
    "BATAAN EXPORT PROCESSING ZONE (BEPZ) MARIVELES",
    "DINALUPIHAN",
    "HERMOSA",
    "LAMAO",
    "LIMAY",
    "MARIVELES",
    "MORONG",
    "ORANI",
    "ORION",
    "PILAR",
    "REFUGEE PROCESSING CENTER (MORONG)",
    "SOUTH UPI",
    "SULTAN KUDARAT",
    "SULTAN SA BARONGIS",
    "TALAYAN",
    "UPI",
    "BOAC",
    "BUENAVISTA",
    "GASAN",
    "MOGPOG",
    "SANTA CRUZ",
    "TORRIJOS",
    "AROROY",
    "BALENO",
    "BALUD",
    "BATUAN",
    "BUENAVISTA",
    "CATAINGAN",
    "CAWAYAN",
    "CLAVERIA",
    "DIMASALANG",
    "ESPERANZA",
    "MANDAON",
    "MASBATE",
    "MILAGROS",
    "MOBO",
    "MONTREAL",
    "PALANAS",
    "PIO V. CRUZ",
    "PLACER",
    "SAN FERNANDO",
    "SAN JACINTO",
    "SAN PASCUAL",
    "USON",
    "ABRA DE ILOG",
    "CALINTAAN",
    "LOOC",
    "LUBANG",
    "MAGSAYSAY",
    "MAMBURAO",
    "PALUAN",
    "RIZAL",
    "SABLAYAN",
    "SAN JOSE",
    "SANTA CRUZ",
    "TILIK",
    "BACO",
    "BANSUD",
    "BONGABON",
    "BULALACAO",
    "TAÑONG",
    "AYALA ALABANG SUBD.",
    "BAYANAN",
    "PUTATAN",
    "BULE",
    "BULE/CUPANG",
    "FILINVEST CORPORATE CITY",
    "BROOKE'S POINT",
    "BUSUANGA",
    "CAGAYANCILLO",
    "CORON",
    "CULION",
    "CUYO",
    "DUMARAN",
    "EL NIDO (BAQUIT)",
    "IWAHIG PENAL COLONY",
    "KALAYAAN",
    "LINAPACAN",
    "MAGSAYSAY",
    "NARRA (PANACAN)",
    "PINAGKAISAHAN",
    "PINYAHAN",
    "PROJECT 4",
    "PROJECT 6",
    "PROJECT 7",
    "PROJECT 8",
    "QUIRINO DISTRICT",
    "PROJECT 2 & 3",
    "QUEZON CITY CPO",
    "RAMON MAGSAYSAY",
    "ROXAS DISTRICT",
    "SACRED HEART",
    "ST. MARTIN DE PORRES",
    "ST. IGNATIUS",
    "ST. PETER",
    "SALVACION",
    "SAN AGUSTIN",
    "SAN ANTONIO",
    "SAN BARTOLOME",
    "SANGANDAAN",
    "SAN ISIDRO",
    "SAN ISIDRO LABRADOR",
    "SAN JOSE",
    "SAN ROQUE",
    "SAN VICENTE",
    "SANTA CRUZ",
    "SANTA LUCIA",
    "SANTA MONICA",
    "EISENHOWER-CRAME",
    "GREENHILLS NORTH",
    "GREENHILLS PO",
    "SAN JUAN CPO",
    "ASIAN DEVELOPMENT BANK",
    "BIBLE CHURCH ON THE AIR",
    "PINABACDAO",
    "SAN JORGE",
    "SAN JOSE DE BAUAN",
    "SAN SEBASTIAN",
    "STA. MARGARITA",
    "STA. RITA",
    "STO. NINO",
    "TAGAPULAN",
    "TALARORA",
    "TARANGNAN",
    "VILLAREAL",
    "WRIGHT (PARANAS)",
    "ZUMARRAGA",
    "ALABEL",
    "GLAN",
    "KIAMBA",
    "MAASIM",
    "MAITUM",
    "MALAPATAN",
    "MALUNGON",
    "ENRILE VILLANUEVA",
    "LARENA",
    "LAZI",
    "MARIA",
    "SAN JUAN",
    "SIQUIJOR",
    "BACON",
    "BARCELONA",
    "BULAN",
    "BULUSAN",
    "CASIGURAN",
    "CASTILLA",
    "DONSOL",
    "GUBAT",
    "IROSIN",
    "JUBAN",
    "MAGALLANES",
    "MATNOG",
    "PILAR",
    "PRIETO DIAZ",
    "STA. MAGDALENA",
    "SORSOGON CITY",
    "BAGUMBAYAN",
    "COLOMBIO",
    "ESPERANZA (AMPATUAN)",
    "ISULAN",
    "KALAMANSIG",
    "LEBAK (SALAMAN)",
    "LUTAYAN",
    "MARIANO MARCOS",
    "PALIMBANG",
    "PRES. QUIRINO",
    "SEN. NINOY AQUINO",
    "SAMAL",
    "BASCO",
    "ITBAYAT",
    "IVANA",
    "MAHATAO",
    "SABTANG",
    "UYUGAN",
    "AGONCILLO",
    "ALITAGTAG",
    "BALAYAN",
    "BALETE",
    "BATANGAS CITY",
      "BAUAN",
      "CALACA",
      "CALATAGAN",
      "CUENCA",
      "FERNANDO AIR BASE",
      "IBAAN",
      "LAUREL",
      "LEMERY",
      "LIAN",
      "LIPA CITY",
      "LOBO",
      "MABINI",
      "MALVAR",
      "MATAAS NA KAHOY",
      "NASUGBU",
      "PADRE GARCIA",
      "ROSARIO",
      "SAN JOSE",
      "SAN JUAN",
      "SAN LUIS",
      "SAN NICOLAS",
      "SAN PASCUAL",
      "MAGSAYSAY",
      "PUERTO PRINCESA CITY",
      "QUEZON",
      "ROXAS",
      "SAN VICENTE",
      "TAYTAY",
      "ANGELES CITY",
      "APALIT",
      "ARAYAT",
      "BACOLOR",
      "BASA AIR BASE",
      "CANDABA",
      "FLORIDABLANCA",
      "GUAGUA",
      "LUBAO",
      "MABALACAT",
      "MACABEBE",
      "MAGALANG",
      "MASANTOL",
      "MEXICO",
      "MINALIN",
      "PORAC",
      "SAN FERNANDO",
      "MUNTINLUPA CPO",
      "PEARL HEIGHTS",
      "PLEASANT VILLAGE",
      "POBLACION",
      "SUSANA HEIGHTS",
      "TUNASAN",
      "AYALA ALABANG P.O. BOXES",
      "FISH MARKET",
      "ISLA DE COCOMO",
      "KAPITBAHAYAN EAST",
      "KAUNLARAN VILLAGE",
      "NAVOTAS",
      "TANGOS",
      "TANZA",
      "AEROPARK SUBDIVISION",
      "BACLARAN",
      "BETTER LIVING SUBD.",
      "BF HOMES 1",
      "BF HOMES 2",
      "EXECUTIVE HEIGHTS SUBD.",
      "IRENEVILLE 1",
      "IRENEVILLE 3",
      "IRENEVILLE 2",
      "MANILA MEMORIAL PARK",
      "MARINA SUBD. (RECLAMATION)",
      "MAYWOOD 1",
      "MAYWOOD 2",
      "MIRAMAR SUBD.",
      "MULTINATIONAL SUBD.",
      "NAIA (AIRPORT)",
      "PARAÑAQUE CPO",
      "PULO",
      "CALAPAN",
      "GLORIA",
      "MANSALAY",
      "POLA",
      "PUERTO GALERA",
      "ROXAS",
      "SAN TEODORO",
      "SOCORRO",
      "VICTORIA",
      "ALORAN",
      "BALIANGAO",
      "BONIFACIO",
      "CALAMBA",
      "CLARIN",
      "CONCEPCION",
      "JIMENEZ",
      "LOPEZ JAENA",
      "INT'L CORRESPONDENCE SCHOOL",
      "RADIO BIBLE CLASS",
      "BAY BREEZE VILLAGE",
      "BICUTAN",
      "LOWER BICUTAN",
      "ARAKAN",
      "BANISILAN",
      "CARMEN",
      "KABACAN",
      "KIDAPAWAN",
      "LIBUNGAN",
      "MAGPET",
      "MAKILALA",
      "MATALAM",
      "MIDSAYAP",
      "M'LANG",
      "PIGKAWAYAN",
      "PIKIT",
      "PRES. ROXAS",
      "TULUNAN",
      "BANGA",
      "GENERAL SANTOS CITY",
      "KORONADAL",
      "NORALA",
      "POLOMOLOK",
      "SANTO NINO",
      "SURALLAH",
      "TAMPACAN",
      "TANTANGAN",
      "TBOLI",
      "TUPI",
      "ASUNCION",
      "BABAK",
      "CARMEN",
      "KAPALONG",
      "KAPUTIAN",
      "NEW CORELLA",
      "PANABO",
      "ISLAND GARDEN CITY OF SAMAL",
      "SAN MARIANO",
      "SAN VICENTE",
      "SANTO TOMAS",
      "TAGUM",
      "BANSALAN",
      "DAVAO CITY",
      "DIGOS",
      "DON MARCELINO",
      "HAGONOY",
      "JOSE ABAD SANTOS",
      "KIBLAWAN",
      "MAGSAYSAY",
      "MALALAG",
      "MALITA",
      "MATANAO",
      "UPPER BICUTAN",
      "TACURONG",
      "INDANAN",
      "JOLO",
      "KALINGALAN KALAUANG",
      "LUGUS",
      "LUUK",
      "MAIMBUNG",
      "MARUNGAS",
      "PANAMAO",
      "PANGLIMA ESTINO",
      "PANGUNTARAN",
      "PARANG",
      "PATA",
      "PATIKUL",
      "SIASI",
      "TALIPAO",
      "TAPUL",
      "TONGKIL",
      "ALEGRIA",
      "BACUAG",
      "BASILISA (RIZAL)",
      "BURGOS",
      "CAGDIANAO",
      "CLAVER",
      "DAPA",
      "DEL CARMEN",
      "DINAGAT",
      "GEN. LUNA",
      "GIGAQUIT",
      "LIBJO (ALBOR)",
      "LORETO",
      "MAINIT",
      "MALIMANO",
      "PILAR",
      "PLACER",
      "SAN BENITO",
      "SAN FRANCISCO",
      "SAN ISIDRO",
      "SAN JOSE",
      "SANTA MONICA",
      "SISON",
      "SOCORRO",
      "SURIGAO CITY",
      "TAGANA-AN",
      "TUBAJON",
      "TUBOD",
      "BAROBO",
      "BAYABAS",
      "BISLIG",
      "CAGWAIT",
      "CANTILLAN",
      "CARMEN",
      "CARRASCAL",
      "CORTEZ",
      "HINATUAN",
      "LANUZA",
      "LIANGA",
      "SAN LUIS",
      "SAN SIMON",
      "SANTA ANA",
      "SANTA RITA",
      "SANTO TOMAS",
      "SASMUAN (OLD: SEXMOAN)",
      "AGNO",
      "AGUILAR",
      "ALAMINOS",
      "ALCALA",
      "ANDA",
      "ASINGAN",
      "BALUNGAO",
      "BANI",
      "BASISTA",
      "BAUTISTA",
      "BAYAMBANG",
      "BINALONAN",
      "BINMALEY",
      "BOLINAO",
      "BUGALLON",
      "BURGOS",
      "CALASIAO",
      "DAGUPAN CITY",
      "DASOL",
      "SANTA TERESITA",
      "SANTO TOMAS",
      "TAAL",
      "TALISAY",
      "TANAUAN CITY",
      "TAYSAN",
      "TINGLOY",
      "TUY",
      "ATOK",
      "BAGUIO CITY",
      "BAKUN",
      "BOKOD",
      "BUGIAS",
      "ITOGON",
      "KABAYAN",
      "KAPANGAN",
      "KIBUNGAN",
      "LA TRINIDAD",
      "LEPANTO",
      "MANKAYAN",
      "PHILIPPINE MILITARY ACADEMY (PMA)",
      "SABLAN",
      "TUBA",
      "TUBLAY",
      "ALMERIA",
      "BILIRAN",
      "CABUCCAYAN",
      "CAIBIRAN",
      "CULABA",
      "KAWAYAN",
      "MARIPIPI",
      "NAVAL",
      "OROQUIETA CITY",
      "OZAMIS CITY",
      "PANAON",
      "PLARIDEL",
      "SAPANG DALAGA",
      "SINACABAN",
      "TANGUB CITY",
      "TUDELA",
      "ALUBIJID",
      "BALINGASAG",
      "BALINGUAN",
      "BINUANGAN",
      "CAGAYAN DE ORO CITY",
      "CLAVERIA",
      "EL SALVADOR",
      "GINGOOG CITY",
      "GITAGUM",
      "INITAO",
      "JASAAN",
      "KINOGITAN",
      "LAGONGLONG",
      "LAGUIDINGAN",
      "LIBERTAD",
      "LUGAIT",
      "MAGSAYSAY",
      "MANTICAO",
      "MEDINA",
      "NAAWAN",
      "OPOL",
     
        "SALAY",
        "SUGBONGCOGON",
        "SAN ANTONIO VALLEY 1",
        "SAN ANTONIO VALLEY 11",
        "SAN ANTONIO VALLEY 12",
        "MERVILE PARK SUBD.",
        "MOONWALK SUBDIVISION",
        "SOUTH ADMIRAL VILLAGE",
        "SANTO NIÑO",
        "TAMBO",
        "UNITED PARANAQUE SUBD.",
        "DOMESTIC AIRPORT P.O.",
        "MANILA BAY RECLAMATION",
        "MALL OF ASIA COMPLEX (MOA)",
        "PASAY CITY CPO - MALIBAY",
        "PICC RECLAMATION AREA",
        "SAN ISIDRO",
        "SAN JOSE",
        "SAN RAFAEL",
        "WESTERN BICUTAN",
        "LIGID",
        "NICHOLS-MCKINLEY",
        "TUKUKAN",
        "ARKONG BATO",
        "RINCON",
        "PASOLO",
        "MALANDAY",
        "POLO",
        "MABOLO",
        "BALANGKAS",
        "CALOONG",
        "DALANDAN WEST, CANUMAY",
        "EAST CANUMAY",
        "LAWANG BATO PUNTURIN",
        "FORTUNE VILLAGE",
        "PASEO DE BLAS",
        "GEN. T DE LEON",
        "KARUHATAN",
        "LINGUNAN",
        "MAPULANG LUPA",
        "VALENZUELA CPO, MALINTA",
        "VALENZUELA CITY",
        "FAR EASTERN BROADCASTING",
        "FEBLAS COL. OF BIBLE",
        "BANGUED",
        "BOLINEY",
        "BUCAY",
        "BUCLOC",
        "DAGUIOMAN",
        "DANGLAS",
        "DOLORES",
        "LACUB",
        "LANGAGILANG",
        "LAGAYAN",
        "LANGIDEN",
        "LA PAZ",
        "LICUAN (BAAY)",
        "LUBA",
        "MALIBCONG",
        "MANABO",
        "PEÑARUBIA",
        "PIDIGAN",
        "PADADA",
        "SANTA CRUZ",
        "SANTA MARIA",
        "SARANGANI",
        "BAGANGA",
        "BANAYBANAY",
        "BOSTON",
        "CARAGA",
        "CATEEL",
        "LINGIG",
        "MADRID",
        "MARIHATAG",
        "SAN AGUSTIN",
        "SAN MIGUEL",
        "TAGBINA",
        "TAGO",
        "TANDAG",
        "ANAO",
        "BAMBAN",
        "CAMILING",
        "CAPAS",
        "CONCEPCION",
        "GERONA",
        "LA PAZ",
        "MAYANTOC",
        "MONCADA",
        "PANIQUI",
        "PURA",
        "RAMOS",
        "SAN CLEMENTE",
        "SAN MANUEL",
        "SAN MIGUEL",
        "STA. IGNACIA",
        "TARLAC",
        "VICTORIA",
        "BALIMBING",
        "BONGAO",
        "CAGAYAN DE SULU",
        "LANGUYAN",
        "SAPA-SAPA",
        "SIMUNOL",
        "SITANGKAI",
        "SOUTH UBIAN",
        "TAGANAK (TURTLE ISLAND)",
        "TANDU BAS",
        "BOTOLAN",
        "CABANGAN",
        "CANDELARIA",
        "CASTILLEJOS",
        "IBA",
        "MASINLOC",
        "OLONGAPO CITY",
        "PALAUIG",
        "SAN ANTONIO",
        "SAN FELIPE",
        "SAN MARCELINO",
        "SAN NARCISO",
        "STA. CRUZ",
        "SUBIC",
        "BALIGUIAN",
        "DAPITAN CITY",
        "DIPOLOG CITY",
        "GUTALAC",
        "JOSE DALMAN (PONOT)",
        "ALBUQUERQUE",
        "ALICIA",
        "ANDA",
        "ANTIQUERA",
        "BACLAYON",
        "BALILIHAN",
        "BATUAN",
        "BIEN UNIDO",
        "BILAR",
        "BUENAVISTA",
        "CALAPE",
        "CANDIJAY",
        "CARLOS P. GARCIA (DAO)",
        "CARMEN",
        "CATIGBI-AN",
        "CLARIN",
        "CORELLA",
        "MAIGO",
        "MATUGAO",
        "MUNAI",
        "NUNUNGAN",
        "PANTAO RAGAT",
        "PANTAR",
        "POONA PIAGAPO",
        "SALVADOR",
        "SAPAD",
        "TAGOLOAN",
        "TANGKAL",
        "TUBOD",
        "BACOLOD GRANDE",
        "BLABAGAN",
        "BALINDONG",
        "BAYANG",
        "BINIDAYAN",
        "BAUMBARAN",
        "BUTIG",
        "CALANOGAS",
        "GANASSI",
        "LUMBATAN",
        "LUMBAYANAGUE",
        "MACADOR ANDONG",
        "MADALUM",
        "MADAMBA",
        "MALABANG",
        "MARAGONG",
        "PAGAYAWAN",
        "PUALAS",
        "SULTAN GUMANDER",
        "TAGOLOAN II",
        "TUBARAN",
        "TUGAYA",
        "BUADIPOSO BUNTONG",
        "BUBONG",
        "KAPAL",
        "LUMBA BAYABAO",
        "MAGUING",
        "SAN ROQUE",
        "STA. CLARA",
        "VILLAMOR AIRBASE",
        "CANIOGAN",
        "GREEN PARK",
        "KAPITOLYO",
        "MANGGAHAN",
        "MAYBUNGA",
        "ORTIGAS PO",
        "PASIG CPO",
        "PINAGBUHATAN",
        "ROSARIO",
        "SAN JOAQUIN",
        "SANTOLAN",
        "STA. LUCIA",
        "UGONG",
        "AGUHO",
        "STA. ANA",
        "ALICIA",
        "AMIHAN",
        "APOLONIO SAMSON",
        "BAESA",
        "BAGBAG",
        "LAGONOY",
        "LIBMANAN",
        "LUPI",
        "MAGARAO",
        "MILAOR",
        "MINALABAC",
        "NABUA",
        "NAGA CITY",
        "OCAMPO",
        "PAMPLONA",
        "PASACAO",
        "PILI",
        "PRESENTACION",
        "RAGAY",
        "SAGNAY",
        "SAN FERNANDO",
        "SAN JOSE",
        "SIPOCOT",
        "SIRUMA",
        "TIGAON",
        "TINAMBAC",
        "CATARMAN",
        "GUINSILIBAN",
        "MAHINOG",
        "MAMBAJAO",
        "SAGAY",
        "CUARTERO",
        "DAO",
        "DUMALAG",
        "DUMARAO",
        "IVISAN",
        "JAMINDAN",
        "MA-AYON",
        "MAMBUSAO",
        "PANAY",
        "GOV. GENEROSO",
        "LUPON",
        "BUENAVISTA",
        "JORDAN",
        "NUEVA VALENCIA",
        "AGUINALDO",
        "ASIPULO",
        "BANAUE",
        "HINGYON",
        "HUNGDUAN",
        "KIANGAN",
        "LAGAWE",
        "LAMUT",
        "MAYAOYAO / MAYOYAO",
        "POTIA",
        "TINOC",
        "ADAMS",
        "BACARRA",
        "BADOC",
        "BANGUI",
        "BATAC",
        "BURGOS",
        "CARASI",
        "CURRIMAO",
        "DINGRAS",
        "DUMALNEG",
        "ESPIRITU",
        "LAOAG CITY",
        "MARCOS",
        "NUEVA ERA",
        "PAGUDPUD",
        "PAOAY",
        "PASUQUIN",
        "PIDDIG",
        "PINILI",
        "SAN NICOLAS",
        "SARRAT",
        "SOLSONA",
        "VINTAR",
        "ALILEM",
        "BINAYOYO",
        "BANTAY",
        "BURGOS",
        "CABUGAO",
        "CANDON",
        "CAOAYAN",
        "CERVANTES",
        "GALIMUYOD",
        "GREGORIO DEL PILAR",
        "LIDILDA",
        "MAGSINGAL",
        "NAGBUKEL",
        "NARVACAN",
        "QUIRINO",
        "SALSEDO",
        "SAN EMILIO",
        "SAN ESTEBAN",
        "SAN ILDEFONSO",
        "KALAWIT",
        "KATIPUNAN",
        "LABASON",
        "LA LIBERTAD",
        "LILOY",
        "MANUKAN",
        "MUTIA",
        "PINAN",
        "POLANCO",
        "RIZAL",
        "ROXAS",
        "SALUG",
        "SERGIO OSMENA",
        "SIAYAN",
        "SIBUCO",
        "SIBUTAD",
        "SINDANGAN (LEON B. POSTIGO)",
        "SIOCON",
        "SIRAWAY",
        "MARANGTAO",
        "MARAWI CITY",
        "MASIO",
        "MULONDO",
        "PIAGAPO",
        "POONA BAYABAO",
        "RAMAIN-DITSAAN",
        "SAGUIARAN",
        "CAPITOL PARKLAND SUBD.",
        "KAYBIGA/DEPARO",
        "LILLES VILLE SUBD.",
        "NOVALICHES NORTH",
        "TALA LEPROSARIUM",
        "VICTORY HEIGHTS",
        "1ST AVENUE WEST",
        "2ND AVENUE WEST",
        "3RD AVENUE WEST",
        "4TH AVENUE WEST",
        "5TH AVENUE WEST",
        "6TH AVENUE WEST",
        "7TH AVENUE WEST",
        "BAESA",
        "FISH MARKET",
        "GRACE PARK EAST",
        "GRACE PARK WEST",
        "ISLA DE COCOMO",
        "CALOOCAN CITY CPO",
        "KAPITBAHAYAN EAST",
        "KANLURAN VILLAGE",
        "MAYPAJO",
        "SAN JOSE",
        "SANGANDAAN",
        "STA. QUITERIA",
        "UNIVERSITY HILLS",
        "ALMANZA",
        "ANGELA VILLAGE",
        "CUT-CUT",
        "GATCHALIAN SUBD.",
        "LAS PINAS CPO",
        "MANILA DOCTOR'S VILLAGE",
        "MANUYO",
        "REMARVILLE SUBD.",
        "SOLDIERS HILLS SUBD.",
        "TALON MOONWALK",
        "T. S. CRUZ SUBD.",
        "VERDANT ACRES SUBD.",
        "PINAMALAYAN",
        "TALAINGOD",
        "SAN MANUEL",
        "MARBEL",
        "LAKE SEBU",
        "MARULAS",
        "SAN ISIDRO",
        "SULOP",
        "ZAMBOANGA SIBUGAY",
        "USUSAN",
        "TARRAGONA",
        "GREENFIELD DISTRICT",
        "SAN DIONISIO",
        "SANTO DOMINGO (MATALAHIB)",
        "BONIFACIO GLOBAL CITY",
        "PARANAS",
        "SAN ISIDRO",
        "MANAY",
        "RODRIGUEZ",
        "PINAGSAMA",
        "SAN ROQUE" 

  ],
  state :[
    
      "DAVAO ORIENTAL",
      "NEGROS OCCIDENTAL",
      "QUEZON CITY",
      "DAVAO DEL NORTE",
      "ORIENTAL MINDORO",
      "LA UNION",
      "LEYTE",
      "LAS PINAS CITY",
      "MAKATI CITY",
      "CAPIZ",
      "CATANDUANES",
      "ILOCOS SUR",
      "ILOILO",
      "ZAMBOANGA DEL NORTE",
      "ZAMBOANGA DEL SUR",
      "QUEZON PROVINCE",
      "PANGASINAN",
      "BOHOL",
      "CAVITE",
      "DAVAO DE ORO",
      "CEBU",
      "MISAMIS ORIENTAL",
      "BASILAN",
      "QUIRINO PROVINCE",
      "ISABELA",
      "BUKIDNON",
      "MALABON CITY",
      "MANDALUYONG CITY",
      "MOUNTAIN PROVINCE",
      "ABRA",
      "AGUSAN DEL NORTE",
      "AGUSAN DEL SUR",
      "AKLAN",
      "MARIKINA CITY",
      "BULACAN",
      "COTABATO",
      "NEGROS ORIENTAL",
      "LAGUNA",
      "KALINGA",
      "APAYAO",
      "CAGAYAN",
      "SOUTHERN LEYTE",
      "MAGUINDANAO",
      "NUEVA ECIJA",
      "RIZAL PROVINCE",
      "ROMBLON",
      "EASTERN SAMAR",
      "ALBAY",
      "ANTIQUE",
      "AURORA",
      "BATAAN",
      "CAMARINES NORTE",
      "CAMARINES SUR",
      "NUEVA VIZCAYA",
      "PALAWAN",
      "NORTHERN SAMAR",
      "SAMAR",
      "LANAO DEL NORTE",
      "CITY OF MANILA",
      "CALOOCAN CITY",
      "MARINDUQUE",
      "MASBATE",
      "OCCIDENTAL MINDORO",
      "MUNTINLUPA CITY",
      "SAN JUAN CITY",
      "SARANGANI",
      "SIQUIJOR",
      "SORSOGON",
      "SULTAN KUDARAT",
      "BATANES",
      "BATANGAS",
      "PAMPANGA",
      "NAVOTAS CITY",
      "PARANAQUE CITY",
      "MISAMIS OCCIDENTAL",
      "TAGUIG CITY",
      "SOUTH COTABATO",
      "DAVAO DEL SUR",
      "DAVAO OCCIDENTAL",
      "SULU PROVINCE",
      "SURIGAO DEL NORTE",
      "DINAGAT ISLANDS",
      "SURIGAO DEL SUR",
      "BENGUET",
      "BILIRAN",
      "PASAY CITY",
      "VALENZUELA CITY",
      "TARLAC",
      "TAWI-TAWI",
      "ZAMBALES",
      "PASIG CITY",
      "PATEROS CITY",
      "CAMIGUIN",
      "GUIMARAS",
      "IFUGAO",
      "ILOCOS NORTE"
  
  

  ]
};
export default data;